import clsx from "clsx";

export type EmptyStateVariant =
  | "neutral"
  | "info"
  | "warning"
  | "error"
  | "success";

type EmptyStateProps = {
  title: string;
  description?: string;
  sub?: string;
  illustration?: React.ReactNode;
  action?: React.ReactNode;
  variant?: EmptyStateVariant;
  className?: string;
  descriptionMaxWidth?: boolean; // NEW prop
};

export function EmptyState({
  title,
  description,
  sub,
  illustration,
  action,
  variant = "neutral",
  className,
  descriptionMaxWidth = true,
}: EmptyStateProps) {
  return (
    <div
      role="status"
      className={clsx(
        "flex flex-col items-center justify-center text-center",
        "px-6 py-10",
        "text-neutral-600",
        className
      )}
    >
      {illustration && <div className="opacity-200 mb-6">{illustration}</div>}

      <h3 className="mb-2 text-xl font-medium text-neutral-600">{title}</h3>

      {description && (
        <p
          className={clsx(
            "mb-1 text-xs leading-5 text-neutral-600",
            descriptionMaxWidth ? "max-w-[300px]" : "w-full"
          )}
        >
          {description}
        </p>
      )}
      {sub && <p className="max-w-[260px] text-xs text-neutral-600">{sub}</p>}

      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
